$(document).ready(function($) {
    // $(document).ready(function () {
  
        //EqGrid JS 
        eqgrid = {
          	_$selector: null,
          	_measure: null,
            init: function($selector,measure){
                this._$selector = $selector;
                this._measure = measure;
                var el = this;
      
                $.each($selector,function(i,obj){
                    var $items = $(obj).find(measure);
                	el.getMax($items);
                });
                el.events.init(this);
            },
            events: {
                init: function(el){
                    this.onWindowResize(el);
                },
                onWindowResize: function(el){
                    $(window).on("resize",function(){
                      console.log('resize');
                      console.log(el);
                       $(el._measure).css("height","auto");
                        
                        var w = $(window).width();
                        if(w > 995){
                        $.each(el._$selector,function(i,obj){
                            var $items = $(obj).find(el._measure);
                            el.getMax($items);
                        });
                        }
                    });
                }
            },
            getMax: function($items){
                var max = 0;
                $.each($items, function (i, obj) {
                    var h = $(obj).height();
                    if (h > max) {
                        max = h;
                    }
                });
              console.log('set items to: ', max);
                this.setHeight($items, max);
            },
            setHeight: function($items,height){
                $items.height(height);
            }
        }
        eqgrid.init($(".eqGrid"), ".eqgrid-item");
});